"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripULuna = exports.stripUUSD = void 0;
function stripUUSD(uusd) {
    return uusd.substring(0, uusd.length - 4);
}
exports.stripUUSD = stripUUSD;
function stripULuna(uluna) {
    return uluna.substring(0, uluna.length - 5);
}
exports.stripULuna = stripULuna;
//# sourceMappingURL=terra.js.map